import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Header from "./Common/header";
import {
  CircularContainer,
  Text1,
  Text2,
  CircularText,
  CircularContainerSmall,
  CircularTextSmall,
} from "./Common/common";
import CalculateFinancialScore from "./Modal";
import { ProceedButton, Footer } from "../OnBoarding/components/Common/Common";
import Vector from "../../assets/images/Group 1000005612.svg";
import { useNavigate } from "react-router-dom";
import ScoreComponent from "./ScoreScreen";

// Gradient Background with type for `blur` prop
interface GradientBackgroundProps {
  blur: boolean;
}

const GradientBackground = styled.div<GradientBackgroundProps>`
  background: linear-gradient(
    190.32deg,
    #047a8d 1.67%,
    #079696 23.32%,
    #80c49f 95.82%
  );
  min-height: 100vh;

  display: flex;
  flex-direction: column;
  justify-content: space-between; /* Align content within the gradient */
  align-items: center;
  padding: 0;
  margin: 0;
`;

const ContentContainer = styled.div`
  text-align: center;
  color: white;
  gap: 15px;
  flex-grow: 1; /* Ensures content area fills available space */
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const CircleRow = styled.div`
  display: flex;
  justify-content: space-between; /* Distributes the circles across the row */
  gap: 40px; /* Adds space between the circles */
  margin-bottom: 20px; /* Space between circles and footer */
`;

const VectorImage = styled.img`
  width: 100%; /* Stretches the vector image to full screen width */
  height: 85.39px; /* Set the height */
  border-top: 2.5px solid transparent; /* Adds a border to the top of the image */
  object-fit: contain; /* Ensures the aspect ratio is maintained */
`;
const Text1Container = styled.div`
  width: 70%; /* Limits the width of the container to 70% */
  margin: 0 auto; /* Centers the container horizontally */
`;
const Text2Container = styled.div`
  display: flex;
  justify-content: space-between; /* Ensures space between the two text blocks */
  gap: 50px; /* Adds space between the health and finance text */
  margin-bottom: 20px; /* Adds space between the text and circles */
`;

const Text3Container = styled.div`
  width: 70%; /* Limits the width of the container to 70% */
  margin: 0 auto; /* Centers the container horizontally */
`;

export const Text3 = styled.p`
  font-family: sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 19.36px;
  text-align: center;
  margin: 15px;
`;

const Card = styled.div`
  background: white;
  border-radius: 10px;
  padding: 15px;
  width: 120px;
  text-align: center;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
`;

const CardIcon = styled.div`
  font-size: 24px;
  margin-bottom: 5px;
`;

const CardTitle = styled.p`
  font-size: 14px;
  color: #6b6b6b;
`;

const CardValue = styled.p`
  font-size: 18px;
  font-weight: bold;
  color: #000;
`;

const RiskCard = styled.div`
  background: white;
  border-radius: 10px;
  padding: 15px;
  width: 250px;
  text-align: center;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
`;

const RiskText = styled.p`
  font-size: 14px;
  color: #6b6b6b;
`;

const RiskValue = styled.p`
  font-size: 16px;
  font-weight: bold;
  color: #000;
`;

const RiskIcon = styled.div`
  font-size: 24px;
  color: gold;
`;

const GradientBackgroundPage: React.FC = () => {
  const [showModal, setShowModal] = useState(true);
  const [healthScore, setHealthScore] = useState(0);
  const averageScore = Math.round((healthScore + 82) / 2);
  const [riskCategory, setRiskCategory] = useState("");
  const [recommendation, setRecommendation] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    // Hide the modal after 3 seconds
    const timer = setTimeout(() => {
      localStorage.removeItem("scanDone");
      const fetchHealthScore = localStorage.getItem("healthScore");
      setHealthScore(parseInt(fetchHealthScore));
      setShowModal(false);
      recommendationText(parseInt(fetchHealthScore));
    }, 3000);
    return () => clearTimeout(timer);
  }, []);


  const recommendationText = (healthScore: number) => {
    if (healthScore >= 85) {
      setRiskCategory("Low Risk");
      setRecommendation("Eligible for Standard Premium");
    } else if (healthScore >= 70) {
      setRiskCategory("Moderate Risk");
      setRecommendation("Eligible with Loading");
    } else if (healthScore >= 50) {
      setRiskCategory("High Risk");
      setRecommendation("Medical Tests Required");
    } else {
      setRiskCategory("Very High Risk");
      setRecommendation("Detailed Medical Evaluation Required");
    }
  };

  return (
    <>
      {/* Conditionally Render Modal */}
      {showModal && <CalculateFinancialScore />}

      {/* Render Gradient Background */}
      {!showModal && <ScoreComponent />}
    </>
  );
};

export default GradientBackgroundPage;
